import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=6400f706"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Video.vue').default})
